import React, { Component, Fragment, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Col} from "reactstrap";
import classes from './contact.module.scss';
import moment from 'moment-timezone';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import StarIcon from '@mui/icons-material/Star';
import axios from "axios";
import { Divider, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { boxiPrimary } from "../../../../assets/style/colors";
import PersonIcon from '@mui/icons-material/Person';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';
import PhotoCameraRoundedIcon from '@mui/icons-material/PhotoCameraRounded';

// phase 1 
const Contact = ({ onContactClick, contact, selectedContact, getChatsCount }) => {

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const generateAvatarBackgroundColor = (name) => {
    let numericValue = 0;
    for (let i = 0; i < name.length; i++) {
      numericValue += name.charCodeAt(i);
    }
    const hue = numericValue % 360; // Use modulo to restrict the hue to a range of 0-359
    const saturation = 70; // Set a fixed saturation value
    const lightness = 50; // Set a fixed lightness value
    const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    return color;
  };

  const markVendorAsStarred = async (vendor_id, phone_number) => { 
    try {
      await axios.post(`${process.env.REACT_APP_API_HOST}/communication/mark-starred`, { vendor_id, phone_number, starred_by: JSON.parse(localStorage.getItem("userId")) });
      setAnchorEl(null);
      getChatsCount();
    } catch (error) {
      console.log(error);
    }
  }

  const removeFromStarred = async (phone_number) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_HOST}/communication/remove-starred/${phone_number}`);
      setAnchorEl(null);
      getChatsCount();
    } catch (error) {
      console.log(error);
    }
  }

  const markAsRead = async (phone_number) => { 
    try {
      await axios.patch(`${process.env.REACT_APP_API_HOST}/communication/mark-read/${phone_number}`);
      setAnchorEl(null);
      getChatsCount();
    } catch (error) {
      console.log(error);
    }
  }

  const markAsUnread = async (phone_number) => {
    try {
      await axios.patch(`${process.env.REACT_APP_API_HOST}/communication/mark-unread/${phone_number}`);
      setAnchorEl(null);
      getChatsCount();
    } catch (error) {
      console.log(error);
    }
  }

  const markVendorAsAccounting = async (vendor_id, phone_number) => { 
    try {
      await axios.post(`${process.env.REACT_APP_API_HOST}/communication/mark-accounting/${phone_number}`, { vendor_id, phone_number, added_by: JSON.parse(localStorage.getItem("userId")) });
      setAnchorEl(null);
      getChatsCount();
    } catch (error) {
      console.log(error);
    }
  }

  
  const removeFromAccounting = async (phone_number) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_HOST}/communication/remove-accounting/${phone_number}`);
      setAnchorEl(null);
      getChatsCount();
    } catch (error) {
      console.log(error);
    }
  }
  
  const markVendorAsPictures = async (vendor_id, phone_number) => { 
    try {
      await axios.post(`${process.env.REACT_APP_API_HOST}/communication/mark-pictures/${phone_number}`, { vendor_id, phone_number, added_by: JSON.parse(localStorage.getItem("userId")) });
      setAnchorEl(null);
      getChatsCount();
    } catch (error) {
      console.log(error);
    }
  }

  const removeFromPictures = async (phone_number) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_HOST}/communication/remove-pictures/${phone_number}`);
      setAnchorEl(null);
      getChatsCount();
    } catch (error) {
      console.log(error);
    }
  }

  return (    
    <div className={!contact.is_read ? classes.isUnread : classes.contantCardContainer} style={{ background: `${selectedContact == contact.phone_number ? '#e3e3e3' : 'white'}` }}>
      <div className={`d-flex p-2 border border-1 border-top-0 border-right-0 border-left-0 ${classes.contactCard}`} style={{ cursor: 'pointer', columnGap: 10 }} onClick={onContactClick}>
          {contact.name && <div className={classes.picture} style={{ backgroundColor: generateAvatarBackgroundColor(contact.name) }}>
            {contact.name[0] === '+' ? <PersonIcon /> : contact.name.trim().split(' ').slice(0,2).reduce((acc, name) => acc+name[0],'')}
            {!contact.is_read && <div className={classes.unread_count}></div>}
            </div>}
          <div className="overflow-hidden" style={{ marginRight: '30px' }}>
            <div className="overflow-hidden text-truncate" style={{fontSize: '15px', fontWeight: '500'}}>{contact.name}</div>
            <div className="overflow-hidden text-truncate" style={{fontSize: '12px'}}>{contact.body}</div>
          </div>
          <div className="d-flex align-items-center align-self-baseline justify-content-end flex-grow-1">
            <div style={{fontSize: '12px'}}>{moment.tz(contact.created_at, 'America/Los_Angeles').fromNow()}</div>
          </div>
      </div>
      {contact.is_starred && <StarIcon className={classes.starIcon} />}
      {contact.is_accounting && <AttachMoneyRoundedIcon className={classes.accountingIcon} />}
      {contact.is_pictures && <PhotoCameraRoundedIcon className={classes.pictureIcon} />}

      <MoreHorizIcon onClick={handleClick} className={classes.moreIcon} />

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <List sx={{ width: '100%', maxWidth: 360, paddingTop: '4px', paddingBottom: '4px' }} component="nav" aria-label="vendor-options">
          <ListItemButton sx={{ paddingTop: 0, paddingBottom: 0 }}>
            {!contact.is_starred && <ListItemText disableTypography={true} sx={{ cursor: 'pointer', fontFamily: 'Poppins', fontSize: 12 }} onClick={() => markVendorAsStarred(contact.vendor_id, contact.phone_number)} primary="Mark As Starred" />}
            {contact.is_starred && <ListItemText disableTypography={true} sx={{ cursor: 'pointer', fontFamily: 'Poppins', fontSize: 12 }} onClick={() => removeFromStarred(contact.phone_number)} primary="Remove From Starred" />}
          </ListItemButton>
          <Divider />
          <ListItemButton disabled={contact?.phone_number === selectedContact} sx={{ paddingTop: 0, paddingBottom: 0 }}>
            {!contact.is_read && <ListItemText disableTypography={true} sx={{ cursor: 'pointer', fontFamily: 'Poppins', fontSize: 12 }} onClick={() => markAsRead(contact.phone_number)} primary="Mark As Read" />}
            {contact.is_read && <ListItemText disableTypography={true} sx={{ cursor: 'pointer', fontFamily: 'Poppins', fontSize: 12 }} onClick={() => markAsUnread(contact.phone_number)} primary="Mark As Unread" />}
          </ListItemButton>
          <Divider />
          <ListItemButton sx={{ paddingTop: 0, paddingBottom: 0 }}>
            {!contact.is_accounting && <ListItemText disableTypography={true} sx={{ cursor: 'pointer', fontFamily: 'Poppins', fontSize: 12 }} onClick={() => markVendorAsAccounting(contact.vendor_id, contact.phone_number)} primary="Mark As Accounting" />}
            {contact.is_accounting && <ListItemText disableTypography={true} sx={{ cursor: 'pointer', fontFamily: 'Poppins', fontSize: 12 }} onClick={() => removeFromAccounting(contact.phone_number)} primary="Remove from Accounting" />}
          </ListItemButton>
          <Divider />
          <ListItemButton sx={{ paddingTop: 0, paddingBottom: 0 }}>
            {!contact.is_pictures && <ListItemText disableTypography={true} sx={{ cursor: 'pointer', fontFamily: 'Poppins', fontSize: 12 }} onClick={() => markVendorAsPictures(contact.vendor_id, contact.phone_number)} primary="Mark As Pictures" />}
            {contact.is_pictures && <ListItemText disableTypography={true} sx={{ cursor: 'pointer', fontFamily: 'Poppins', fontSize: 12 }} onClick={() => removeFromPictures(contact.phone_number)} primary="Remove from Pictures" />}
          </ListItemButton>
        </List>
      </Popover>
    </div>   
  );
}
export default Contact;